// extracted by mini-css-extract-plugin
module.exports = {"medium":"cards_medium__2wdni","cardbg":"cards_cardbg__pHQ8a","header":"cards_header__mMfqW","iconcolor":"cards_iconcolor__1JqZ_"};